import * as React from "react";
const SvgVickyFineartSaveSelection = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-fc0c16be-6bcc-4920-8494-3e9da0658063", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 75.55 75.55", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "74.05 74.05 1.5 74.05 1.5 1.5 65.39 1.5 74.05 9.58 74.05 74.05", style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("path", { d: "M19.43,1.5H56.12V25.21c0,2.14-1.74,3.88-3.88,3.88H23.31c-2.14,0-3.88-1.74-3.88-3.88V1.5h0Z", style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("rect", { x: 43.9, y: 7.86, width: 6.14, height: 14.87, rx: 0.12, ry: 0.12, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("rect", { x: 12.82, y: 39.28, width: 49.91, height: 24.28, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("line", { x1: 22.99, y1: 46.44, x2: 52.57, y2: 46.44, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("line", { x1: 22.99, y1: 51.88, x2: 52.57, y2: 51.88, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("line", { x1: 22.99, y1: 57.32, x2: 52.57, y2: 57.32, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3
} }));
export default SvgVickyFineartSaveSelection;
